export default "__VITE_ASSET__Bx98$Zdz__"